import { ISitePage } from 'core-components/sitebuilder/models/ISitePage'
import { StorageApi } from 'src/core/classes/services/api/StorageApi'
import { KEY_SITEPAGES_LAYOUT_DATA } from 'src/core/components/app/loaders/constants/sitePage'
import { ILayoutDataCache } from 'src/core/components/app/loaders/models/ISitePageCache'

export const persistSitePageLayoutData = async (sitePages: ISitePage[]) => {
  const sitePageLayoutData: ILayoutDataCache = {}
  sitePages.forEach((sitePage) => {
    if (
      sitePage.layoutUser !== sitePage.layout ||
      JSON.stringify(sitePage.layoutUserSettings) !== JSON.stringify(sitePage.layoutSettings)
    ) {
      sitePageLayoutData[sitePage.id] = {
        layout: sitePage.layoutUser,
        layoutSettings: sitePage.layoutUserSettings,
      }
    }
  })
  await StorageApi.set(KEY_SITEPAGES_LAYOUT_DATA, structuredClone(sitePageLayoutData))
}
